import {lazy, FC, Suspense, useEffect} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {CanterasPage} from '../pages/Jeisat/CanterasPage'
import {useQuery} from '@apollo/client'
import {GET_ID_ORGANIZATION} from '../graphql/queries/getOrganization'
import {useGetUser} from '../hooks/useGetUser'
import {IGetIdOrg} from '../graphql/types/globals'
import {ProductsPage} from '../pages/Jeisat/ProductsPage'
import {ClientsPage} from '../pages/Jeisat/ClientsPage'
import {TransportPage} from '../pages/Jeisat/TransportPage'
import {VentasPage} from '../pages/Jeisat/VentasPage'
import {DespachosPage} from '../pages/Jeisat/DespachosPage'
import {AddVentaPage} from '../pages/Jeisat/AddVenta'
import {OneVentaPage} from '../pages/Jeisat/OneVentaPage'
import {AddDispatchPage} from '../pages/Jeisat/AddDispatch'
import {OneDispatch} from '../pages/Jeisat/OneDispatch'
import {hasPermission} from '../helpers'
import {ALL_PERMISSIONS} from '../helpers/consts'

const PrivateRoutes = () => {
  const {data: dataOrg, error: errorOrg} = useQuery<IGetIdOrg>(GET_ID_ORGANIZATION)
  const {updateOrganization, user} = useGetUser()
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  useEffect(() => {
    if (dataOrg) {
      updateOrganization(dataOrg.getOrganization.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataOrg])

  useEffect(() => {
    if (errorOrg) {
      console.log('errorOrg', errorOrg)
    }
  }, [errorOrg])

  if (!user) {
    return (
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path='*' element={<Navigate to='/auth' />} />
        </Route>
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />

        {/* START --> RUTAS JEISAT */}
        <Route
          path='/canteras'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_CANTERA) ? (
              <CanterasPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/productos'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_PRODUCTO) ? (
              <ProductsPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/clientes'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_DE_CLIENTE) ? (
              <ClientsPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/volquetas'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_TRANSPORTE) ? (
              <TransportPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/ventas'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_VENTA) ? (
              <VentasPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/despachos'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_DESPACHO) ? (
              <DespachosPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/agregar-venta'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_VENTA) ? (
              <AddVentaPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/venta/:id'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_VENTA) ? (
              <OneVentaPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/agregar-despacho'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_AGREGAR_DESPACHO) ? (
              <AddDispatchPage />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/despacho/:id'
          element={
            hasPermission(user.tokenAuth.permissions, ALL_PERMISSIONS.PUEDE_CAMBIAR_DESPACHO) ? (
              <OneDispatch />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        {/* END --> RUTAS JEISAT */}

        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
